<template>
    <modal size="lg" :height-max="true" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editDeductionPositionsModal">
        <template v-slot:title>
            <h3 class="modal-title">Edit Positions</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div v-if="deduction.company"><span class="text-muted">Company: </span>{{ deduction.company.name }}</div>
                    <div><span class="text-muted">Deduction: </span>{{ deduction.name || deduction.deduction_type.name }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <p class="mb-0">Select the positions that will use this deduction type.</p>

            <position-selector v-if="positionsLoaded" :all-positions="allCompanyPositions" :companies="client.companies" v-model="formData.positions"/>

        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import PositionSelector from '@/pages/client/Settings/components/PositionSelector'

export default {
    props: ['client', 'deduction', 'setupMode', 'positions'],
    mixins: [FormMixin, ModalMixin],
    components: {PositionSelector, },
    data() {
        return {
            formData: this.makeFormData(),
            allPositions: [],
            positionsLoaded: false,
        }
    },
    watch: {
        deduction() {
            this.reset()
        }
    },
    mounted() {
        this.getPositions()
    },
    computed: {
        allCompanyPositions() {
            if (this.setupMode) {
                return this.allPositions
            }
            return this.allPositions.filter(p => p.company_id == this.deduction.company_id)
        },
    },
    methods: {
        getPositions() {
            this.$api.get(`/clients/${this.client.id}/positions`).then(resp => {
                this.allPositions = resp
                this.allPositions.sort((a, b) => {return a.terminal_value.toLowerCase() > b.terminal_value.toLowerCase() ? 1 : -1})
                this.positionsLoaded = true
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
            })
        },
        makeFormData() {
            const data = {
                positions: []
            }
            if (this.setupMode && this.positions) {
                // data.positions = this.positions
            } else if (this.deduction.positions) {
                this.deduction.positions.forEach(p => {
                    data.positions.push(p.id)
                })
            }
            return data
        },
        onSubmit() {
            if (this.setupMode) {
                this.$emit('updated', this.formData.positions)
                return
            }
            this.$store.dispatch('START_LOADING')
            return this.$api.put(`/clients/${this.client.id}/settings/deduction-types/${this.deduction.id}/positions`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
